import './styles/log-details.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import DetailsHeader  from '../components/DetailsHeader'
import Loading        from '../components/Loading'
import JobLogItem     from '../job/JobLogItem'

import { setDebugLogging } from '../redux/actions/settings'

import { formatTime } from './utils'

class LogDetails extends React.Component {
  static propTypes = {
    match:           PropTypes.object.isRequired,
    getLogFn:        PropTypes.func.isRequired,
    showDebugLogs:   PropTypes.bool.isRequired,
    setDebugLogging: PropTypes.func.isRequired,
    featureFlags:    PropTypes.array.isRequired,
  }

  state = {
    loading: true,
  }

  componentDidMount() {
    const { id } = this.props.match.params

    this.props.getLogFn({ id }).then((result) => {
      this.setState({ loading: false, data: result })
    })
  }

  handleToggleDetails = (event) => {
    event.preventDefault()
    
    const { setDebugLogging, showDebugLogs } = this.props

    setDebugLogging(!showDebugLogs)
  }

  renderRegion = (region) => {
    return (
      <div className="region-marker">
        <div className="ui mini message">
          <div className="title">
            Region:
          </div>
          <div className="message">
            { region }
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { showDebugLogs, featureFlags } = this.props
    const { loading, data } = this.state    

    if (loading) return <Loading />
    
    const time         = formatTime(data?.timestamp)
    const debugMessage = showDebugLogs
      ? 'Hide debug logs'
      : 'Show debug logs'
    
    return (
      <div className="log-details">
        <DetailsHeader title={time} type="Log">
          { data?.region && this.renderRegion(data?.region) }
        </DetailsHeader>

        <div className="log-content">
          {
            featureFlags.includes('enableMonitorDebugLogging') && (
              <div className="toggle-details">
                <a href="/" onClick={this.handleToggleDetails}>{ debugMessage }</a>
              </div>
            )
          }
          <JobLogItem businessLog={data?.businessLog} showDebugLogs={showDebugLogs} />
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {
  setDebugLogging,
}
const mapStateToProps = (state) => ({
  showDebugLogs: state.settings.showDebugLogs,
  featureFlags:  state.features.featureFlags,
})

export default connect(mapStateToProps, mapDispatchToProps)(LogDetails)
